export const profiles = {
    admin: 'admin', 
    user: 'user' 
}